import React from "react";
import ModalTemplate from "~/common/components/ModalPortal/ModalTemplate";

const CompanyModal = ({ companyDetailModal, detail, setCompanyDetailModal, param = 13 }) => {
	return (
		<ModalTemplate
			modalState={companyDetailModal}
			setModalToggle={setCompanyDetailModal}
			title={detail?.company?.name}
			width={640}
			className="company-detail-modal"
		>
			<div className="modal-content">
				<div className="c__form">
					<div className="f__group">
						<div className="f__label">대표</div>
						<div className="f__control">{detail?.company?.ceoName}</div>
					</div>
					<div className="f__group">
						<div className="f__label">매출</div>
						<div className="f__control">
							{detail?.company?.sales}{" "}
							{detail?.company?.salesYear !== null
								? "(" + detail?.company?.salesYear + "년 기준)"
								: ""}
						</div>
					</div>
					<div className="f__group">
						<div className="f__label">업종</div>
						<div className="f__control">{detail?.company?.bizType}</div>
					</div>
					<div className="f__group">
						<div className="f__label">설립일자</div>
						<div className="f__control">
							{detail?.company?.estDate.substring(0, 10)}
						</div>
					</div>
					<div className="f__group">
						<div className="f__label">직원 수</div>
						<div className="f__control">{detail?.company?.employeeNum}</div>
					</div>
					<div className="f__group">
						<div className="f__label">기업구분</div>
						<div className="f__control">{detail?.company?.certType}</div>
					</div>
					<div className="f__group">
						<div className="f__label">국가</div>
						<div className="f__control">
							{detail?.company?.country === "KR" ? "한국" : "기타"}
						</div>
					</div>
					<div className="f__group">
						<div className="f__label">상장구분</div>
						<div className="f__control">
							{detail?.company?.listed ? "상장" : "비상장"}
						</div>
					</div>
					<div className="f__group">
						<div className="f__label">주소</div>
						<div className="f__control">
							({detail?.company?.zipCode}) {detail?.company?.address}
						</div>
					</div>
					<div className="f__group">
						<div className="f__label">홈페이지</div>
						<div className="f__control">{detail?.company?.homepage}</div>
					</div>
				</div>
				<div className="c__form vertical">
					<div className="f__group major-product">
						<div className="f__label">
							주요제품 <span>{detail?.product?.name}</span>
						</div>
						<div className="f__control">{detail?.product?.description}</div>
					</div>
				</div>
			</div>
			<div className="modal-footer">
				<button
					type="button"
					className="btn__solid"
					color="primary"
					onClick={() => setCompanyDetailModal(false)}
				>
					닫기
				</button>
			</div>
		</ModalTemplate>
	);
};

export default CompanyModal;
